import { render, staticRenderFns } from "./RequirementQualityTypeAddNew.vue?vue&type=template&id=06bdd860"
import script from "./RequirementQualityTypeAddNew.vue?vue&type=script&lang=js"
export * from "./RequirementQualityTypeAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports